/* TypeScript file generated from ThumbWithInterest.re by genType. */
/* eslint-disable import/first */


import * as React from 'react';

const $$toRE888505244: { [key: string]: any } = {"Interested": 0, "NotInterested": 1};

// tslint:disable-next-line:no-var-requires
const ThumbWithInterestBS = require('./ThumbWithInterest.bs');

import {SpaceContactInterest_t as Types_SpaceContactInterest_t} from '../../src/Types.gen';

import {style as ReactDOMRe_style} from '../../src/shims/ReactDOMRe.shim';

// tslint:disable-next-line:interface-over-type-literal
export type Props = {
  readonly className?: string; 
  readonly interest?: Types_SpaceContactInterest_t; 
  readonly style?: ReactDOMRe_style; 
  readonly testID?: string; 
  readonly thumbIconSize?: number; 
  readonly thumbSize?: number
};

export const $$default: React.ComponentType<{
  readonly className?: string; 
  readonly interest?: Types_SpaceContactInterest_t; 
  readonly style?: ReactDOMRe_style; 
  readonly testID?: string; 
  readonly thumbIconSize?: number; 
  readonly thumbSize?: number
}> = function ThumbWithInterest(Arg1: any) {
  const $props = {className:Arg1.className, interest:(Arg1.interest == null ? undefined : $$toRE888505244[Arg1.interest]), style:Arg1.style, testID:Arg1.testID, thumbIconSize:Arg1.thumbIconSize, thumbSize:Arg1.thumbSize};
  const result = React.createElement(ThumbWithInterestBS.default, $props);
  return result
};

export default $$default;
